<div mat-dialog-content [innerHTML]="html">
</div>
